import { connect } from 'react-redux';
import { setForceClose } from 'feature/loading-management/carrier-authorizations/store/createNewCarrierAuthSlice';
import { fetchNotifications } from 'notifications/store/NotificationSlice';
import { fetchOpenPTOs } from 'feature/inventory-management/product-transfer-order/store/openOrder';
import { fetchSearchPTOs } from 'feature/inventory-management/product-transfer-order/store/searchOrder';

import DrawerContainer from './DrawerContainer';

const mapState = state => ({
  selfAuthorizationDialogOpen:
    state.loadingManagement.selfAuthorizations.selfAuthorizationDialogOpen,
});

const mapDispatchToProps = {
  fetchNotifications,
  fetchOpenPTOs,
  fetchSearchPTOs,
  setForceClose,
};

export default connect(mapState, mapDispatchToProps)(DrawerContainer);
